import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const OPEN_FEDERATION_CREATE_MODAL = "openFederationCreateModal";
